import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { Button, Input } from '@follow/ui';

import AssetsService from '../../services/AssetsService';

const StationCreate = () => {
  const { siteId } = useParams<{ siteId: string }>();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [token, setToken] = useState('');

  const { data: location } = useQuery({
    queryKey: ['location', siteId],
    queryFn: () => AssetsService.getLocation(Number(siteId)),
    enabled: !!siteId,
    select: (data) => data.location,
  });

  const linkStationMutation = useMutation({
    mutationFn: () =>
      AssetsService.linkStation({
        token: token.trim(),
        lat: location?.lat ?? 0,
        lng: location?.lng ?? 0,
        locationId: Number(siteId),
      }),
    onSuccess: (data) => {
      toast.success('Station ajoutée');
      queryClient.invalidateQueries({ queryKey: ['stations', siteId] });
      navigate(`/site/${siteId}/station/${data.station.id}`);
    },
    onError: () => {
      toast.error('Le token est invalide ou la station est déjà liée');
    },
  });

  const handleCreate = () => {
    if (!token.trim() || location?.lat == null || location?.lng == null) return;
    linkStationMutation.mutate();
  };

  return (
    <>
      <div className="w-full max-w-[640px] px-4 flex flex-col justify-start items-start gap-8">
        <div className="self-stretch inline-flex justify-start items-start gap-4">
          <div className="flex-1 inline-flex flex-col justify-center items-start">
            <h1 className="text-neutral typo-h1">Nouvelle station</h1>
          </div>
        </div>
      </div>
      <div className="w-full max-w-[640px] px-4 flex flex-col justify-start items-start gap-4">
        <h2 className="text-neutral typo-h2">Détails</h2>
        <div className="self-stretch p-4 bg-white rounded-lg shadow-card outline outline-1 outline-offset-[-1px] outline-neutral-10 flex flex-col justify-center items-start gap-6 overflow-hidden">
          <div className="w-full max-w-[480px] flex flex-col justify-start items-start gap-1">
            <label className="self-stretch text-neutral-80 typo-label">
              Token de la station
            </label>
            <Input
              tone="dark"
              type="text"
              value={token}
              placeholder="Scannez le QR code sur la station"
              onChange={(e) => setToken(e.target.value)}
            />
            <span className="text-neutral-40 typo-small">
              Le token se trouve sur le QR code présent sur le système IoT de la station.
            </span>
          </div>
          <div className="self-stretch inline-flex justify-end items-start gap-2">
            <Button variant="outline" size="sm" onClick={() => navigate(`/site/${siteId}`)}>
              Annuler
            </Button>
            <Button
              variant="primary"
              tone="light"
              size="sm"
              onClick={handleCreate}
              disabled={!token.trim()}
              loading={linkStationMutation.isPending}
            >
              Ajouter
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default StationCreate;
